function MsgBus(config) {
    var self = this, iframeWindow=null;
    let iframe;
    let event_ref;

    const getClientConfigs = (clientName) => {
        if (clientName?.toLowerCase() === 'live_schedule') {
            return {
                config: EnvironmentsConfig.get('LiveScheduleIFrameLoginConfig'),
                baseDomain: EnvironmentsConfig.getFullBaseURL()
            };
        }
        else if (clientName?.toLowerCase() === 'bluestone_lane') {
            return {
                config: EnvironmentsConfig.get('blueStoneLaneIFrameLoginConfig'),
                baseDomain: EnvironmentsConfig.getFullBaseURL()
            };
        } else if (clientName?.toLowerCase() === 'jib') {
            return {
                config: EnvironmentsConfig.get('jackInTheBoxIFrameLoginConfig'),
                baseDomain: EnvironmentsConfig.getFullBaseURL()
            };
        } else {
            return {
                config: EnvironmentsConfig.get('IFrameLoginConfig'),
                baseDomain: EnvironmentsConfig.getFullBaseURL()
            };
        }
    };

    const clientConfiguration = getClientConfigs(HStorageManager.get({
        storageLevel: HStorageManager.StorageLevels.COOKIES,
        key: 'client_id'
    }));

    const iframeURL = `${EnvironmentsConfig.getMainDomain()}${clientConfiguration.config.redirectSignIn ?? '/ilm'}`;

    var config = {
        'IFrameURL': iframeURL,
        'mainDomain': EnvironmentsConfig.getMainDomain(),
    };

    var delayedCalls = [];
    var onReady = function(cb){
        !iframeWindow? delayedCalls.push(cb): cb();
    };

    function postMessagePromise(msg) {
        return new Promise(function (resolve, reject) {
            onReady(function (){
                var msgUUID = createUUID();
                event_ref = window.addEventListener("message", function (resp) {
                    if (resp.data && typeof resp.data === "string" && resp.data[0] === "{") {
                        try {
                            var data = JSON.parse(resp.data)
                            if (data && data.uuid && data.uuid === msgUUID) {
                                window.removeEventListener("message", event_ref)
                                resolve(data);
                            }
                        } catch (e) {
                            resolve(resp.data);
                            // reject(e);
                            console.warn(e);
                        }
                    }
                }, false);

                iframeWindow && iframeWindow.postMessage(Object.assign(msg, {uuid: msgUUID}), config['mainDomain'])
            });
        });
    }

    function appendQueryParams(){
        var params = [];
        if( getParameterByName('code')){
            params.push('code=' +getParameterByName('code'));
        }
        if( getParameterByName('state')){
            params.push('state=' +getParameterByName('state'));
        }
        if( getParameterByName('ILM_DEBUG')){
            params.push('ILM_DEBUG');
        }

        let clientId = HStorageManager.get({
            storageLevel: HStorageManager.StorageLevels.COOKIES,
            key: 'client_id'
        });

        if (clientId) {
            params.push(`client=${clientId}`);
        }

        return params;
    }

    function buildIFrame(){
        var iframe = document.createElement('iframe');
        iframe.setAttribute("height", "0px");
        iframe.setAttribute("width", "0px");
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("style", "display: block;");
        iframe.src = config.IFrameURL +'?'+ appendQueryParams().join('&');
        return iframe;
    }

    self.method = function (_method) {
        self.methodToCall = _method;
        self.methodParamsToCall = {};
        return self;
    };

    self.params = function (_params) {
        self.methodParamsToCall = _params;
        return self;
    };

    self.exec = function () {
        return postMessagePromise({
            method: self.methodToCall,
            params: JSON.parse(JSON.stringify(self.methodParamsToCall))
        });
    };

    self.init = function () {
        return new Promise( function (resolve){
            if( iframeWindow ){
                resolve();
            }
            else{
                iframe = buildIFrame();
                iframe.onload = function() {
                    iframeWindow = iframe.contentWindow;
                    resolve();
                    delayedCalls.forEach(function (delayedCall){
                        delayedCall();
                    });
                };
                document.body.appendChild(iframe);
            }
        });
    }

    self.reset = function(){
        document.body.removeChild(iframe);
        window.removeEventListener("message", event_ref)
        iframeWindow = null;
        return self.init();
    }
};

window.MsgBus = MsgBus;